export default __webpack_public_path__ + "static/sa-version-20240717-76ff270c2e6d6448945dd95129c83897.png";